module.exports = __webpack_public_path__ + "frontend/images/faq/screen-promo-xs-993afbb6babc2b05ab33bbbf0ac4a38b.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/frontend/images/faq/screen-promo-xs.jpg
// module id = 338
// module chunks = 2